import _ from 'lodash'
import {useEffect, useState} from 'react'
import {useMeasure} from 'react-use'
// import Plotly, { PlotParams } from 'react-plotly.js';
import PlotlyLib from 'plotly.js-basic-dist-min'
import {PlotParams} from 'react-plotly.js'
import createPlotlyComponent from 'react-plotly.js/factory'
const PlotlyPlot = createPlotlyComponent(PlotlyLib)
import './style.css'

export interface IPlotProps extends Omit<PlotParams, 'layout'> {
  title?: string
  data: PlotlyLib.Data[]
  fluid?: boolean
  layout?: Partial<PlotlyLib.Layout>
  marker?: number
  onPointerEnter?: React.PointerEventHandler<HTMLDivElement> | undefined
  onPointerLeave?: React.PointerEventHandler<HTMLDivElement> | undefined
}

export function Plot(props: IPlotProps) {
  const {title, data, fluid, layout, marker, onPointerEnter, onPointerLeave, ...rest} = props

  // TODO: props
  const backgroundColor = '#28242d'
  const gridColor = 'rgba(255, 255, 255, 0.08)'
  const titleColor = 'rgba(255, 255, 255, 0.7)'
  const labelColor = 'rgba(255, 255, 255, 0.5)'
  const legendColor = 'rgba(255, 255, 255, 0.6)'
  const legendBackgroundColor = 'rgba(0, 0, 0, 0.25)'

  const [ref, {width}] = useMeasure<HTMLDivElement>()

  const [bakedLayout, setBakedLayout] = useState<Partial<PlotlyLib.Layout>>()
  const [bakedConfig, setBakedConfig] = useState<Partial<PlotlyLib.Config>>()

  useEffect(() => {
    if (width === 0) return
    const {shapes, ...layoutRest} = layout || {}
    setBakedLayout({
      title: title,
      ...(!fluid ?
        {
          width: width,
          height: 400,
        }
      : undefined),
      ...(!fluid ?
        {
          margin: {
            t: 40,
            l: 35,
            r: 5,
            b: 35,
          },
        }
      : undefined),
      hovermode: 'closest',
      paper_bgcolor: backgroundColor,
      plot_bgcolor: 'rgba(0, 0, 0, 0)',
      titlefont: {
        color: titleColor,
      },
      legend: {
        bgcolor: legendBackgroundColor,
        font: {
          color: legendColor,
        },
      },
      font: {
        color: titleColor,
      },
      shapes: _.compact([
        ...(shapes || []),
        marker !== undefined ?
          {
            type: 'line',
            x0: marker,
            y0: -1,
            x1: marker,
            y1: 1,
            line: {
              width: 1,
              color: '#ffffff',
              dash: 'solid',
            },
            opacity: 0.6,
          }
        : null,
      ]),
      xaxis: {
        automargin: true,
        fixedrange: true,
        gridcolor: gridColor,
        zerolinecolor: labelColor,
        tickfont: {
          color: labelColor,
        },
      },
      yaxis: {
        automargin: true,
        fixedrange: true,
        gridcolor: gridColor,
        zerolinecolor: labelColor,
        tickfont: {
          color: labelColor,
        },
      },
      ...layoutRest,
    })
  }, [width, layout, fluid, marker])

  useEffect(() => {
    setBakedConfig({
      displayModeBar: false,
      displaylogo: false,
      responsive: fluid,
      // ...config,
    })
  }, [fluid])

  // useEffect(() => {
  //     console.log(bakedLayout);
  // }, [bakedLayout])

  const classNames = _.chain(['plot', fluid ? 'fluid' : undefined])
    .compact()
    .join(' ')
    .value()

  return (
    <div
      className={classNames}
      ref={ref}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
    >
      {bakedLayout ?
        <PlotlyPlot
          data={data}
          layout={bakedLayout}
          config={bakedConfig}
          {...rest}
        />
      : null}
    </div>
  )
}
